<mat-form-field *ngIf="multipleSearch" class="width" appearance="fill">
  <div class="{{chipLists.length > 2 ?'scroll':''}}">
    <mat-chip-list #chipList>
      <mat-chip *ngFor="let element of chipLists" (removed)="remove(element)">
        {{element.displayName}} <{{element.userPrincipalName}}>
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
      </mat-chip>
      <br />
    </mat-chip-list>
  </div>
  <input class="common-text-box inp-textbox" [ngClass]="{
    'nr-err-border': (
      formGroup.get(formControlFieldName).touched && (
      formGroup.get(formControlFieldName).hasError('required') ||
      formGroup.get(formControlFieldName).hasError('incorrect') ||
      formGroup.get(formControlFieldName).hasError('exist'))
    )}" #autoCompleteInput id="{{formControlFieldName}}control" formControlName="{{formControlFieldName}}"
    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" [matAutocomplete]="autocomplete"
    type="{{type}}" placeholder="{{placeholder}}" maxlength="{{mxLength}}">
</mat-form-field>

<input class="common-text-box" *ngIf="!multipleSearch" [ngClass]="{
    'nr-err-border': (
      formGroup.get(formControlFieldName).touched && (
      formGroup.get(formControlFieldName).hasError('required') ||
      formGroup.get(formControlFieldName).hasError('incorrect') ||
      formGroup.get(formControlFieldName).hasError('select') ||
      formGroup.get(formControlFieldName).hasError('exist') ||
      formGroup.get(formControlFieldName).hasError('same'))
    ),
    'nr-war-border': (
      formGroup.get(formControlFieldName).touched && (
      formGroup.get(formControlFieldName).hasError('warning') ||
      formGroup.get(formControlFieldName).hasError('ignoreexist'))
    )
  }" #autoCompleteInput id="{{formControlFieldName}}" formControlName="{{formControlFieldName}}"
  [matAutocomplete]="autocomplete" type="{{type}}" placeholder="{{placeholder}}" maxlength="{{mxLength}}">

<mat-autocomplete #autocomplete="matAutocomplete" showPanel="true" [displayWith]="displayWithFunction"
  (optionSelected)="sendToParent($event.option.value)" (optionsScroll)="onScroll()">
  <ng-container *ngIf="displaySearchFor === 'default'">
    <mat-option *ngFor="let o of options" [value]="o">{{displayWithFunction(o)}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'NamePhoneJob'">
    <mat-option *ngFor="let o of options" [value]="o">
      {{o.displayName}} | {{o.phones[0]?.number}} | {{o.jobTitle}}
    </mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'NameJob'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.displayName}} | {{o.jobTitle}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'NameMail'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.displayName}} <{{o.userPrincipalName}}>
    </mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'Trust'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.trustId}} - {{o.delayDescription}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'SincsIncident'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.reference}} - {{o.description}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'elr'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.elrRef}} | {{o.elrName}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'elrmap'">
    <mat-option *ngFor="let o of options" [value]="o">{{o.elrRef}} | {{o.displayStart}} / {{o.displayEnd}}</mat-option>
  </ng-container>
  <ng-container *ngIf="displaySearchFor === 'equipment'">
    <mat-option *ngFor="let o of options" [value]="o">
      <span *ngIf="o.goldenAssetInd === 'Y'">
        <img class="common-img-icon img-option" src="assets/images/asset-golden.svg" alt="Golden Asset" />
      </span>
      <span *ngIf="o.isKeyAsset">
        <img class="common-img-icon img-option" src="assets/images/key-assetkey.png" alt="Key Asset" />
      </span>
      <span *ngIf="o.isUnverifiedItem">
        <img class="common-img-icon img-option" src="assets/images/asset-uv.svg" alt="Asset Unverified" />
      </span>
      <span *ngIf="o.isNotApplicableItem">
        <img class="common-img-icon img-option" src="assets/images/asset-na.svg" alt="Equipment not applicable" />
      </span>
      <span *ngIf="!(o.goldenAssetInd === 'Y' || o.isKeyAsset || o.isUnverifiedItem || o.isNotApplicableItem)">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span>&nbsp;{{displayWithFunction(o)}}</span>
    </mat-option>
  </ng-container>
</mat-autocomplete>